export enum EContactTopic {
    Calc = 'calc',
    Measure = 'measure',
    Custom = 'custom',
    Materials = 'materials',
    Other = 'other',
}

export enum EContactSubmissionStatus {
    Idle = 'idle',
    Submitting = 'submitting',
    Success = 'success',
    Error = 'error',
}

/**
 * Server-side error contract: `error` discriminates between captcha rejection,
 * field-level validation failures, and the per-IP hourly rate limit. Other
 * values fall back to the generic message.
 */
export enum EContactErrorKind {
    Captcha = 'captcha',
    Validation = 'validation',
    RateLimit = 'rate-limit',
    Generic = 'generic',
}

export interface IContactFormModel {
    name: string;
    email: string;
    phone: string;
    topic: EContactTopic;
    message: string;
    consent: boolean;
    captchaToken: string;
    honeypot: string;
}

export interface IContactFormSubmitPayload {
    readonly email: string;
    readonly message: string;
    readonly 'cf-turnstile-response': string;
    readonly subject: string;
    readonly from_name: string;
    readonly name: string;
    readonly phone: string;
    readonly topic: EContactTopic;
    readonly locale: string;
    readonly honeypot: string;
    readonly renderedAt: number;
    config_json?: string;
}
